/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
import $ from "jquery";

/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
  // Create our event (with options)
  var evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  // If cancelled, don't dispatch our event
  var canceled = !elem.dispatchEvent(evt);
};

$(document).ready(() => {
  // the following code is to force aria-labels on all anchor links
  $("a").each(function () {
    const title = $(this).attr("title") || $(this).text();
    $(this).attr("aria-label", title);
  });

  $(".swiper-slide").each(function () {
    const title = $(this).attr("data-title") || $(this).text();
    $(this).attr("aria-label", title);
  });

  var video360Link = document.querySelector(
    ".vcv-ui-icon-entypo-controller-play"
  );
  $(".clf2020-watch-video-hero p").on("click", () => {
    simulateClick(video360Link);
    $("#clf-watch360-popup").click();
  });
});
